import React from 'react';
import PropTypes from 'prop-types';

function VisaIcon({ className, monochrome }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="64"
      height="36"
      viewBox="0 0 64 36"
      className={className}
    >
      <path
        fill={monochrome ? '#000' : '#005198'}
        d="M32.8 14.7c0 2.2 2 3.5 3.4 4.2 1.5.8 2 1.3 2 2 0 1-1.2 1.4-2.3 1.5-2 0-3-.6-4-1l-.7 3.4c1 .4 2.6.8 4.3.8 4.1 0 6.8-2 6.8-5.3 0-4-5.5-4.3-5.4-6.1 0-.6.5-1.2 1.6-1.3.6-.1 2-.2 3.8.7l.7-3.3a10 10 0 0 0-3.6-.7c-3.9 0-6.6 2.1-6.6 5.1M49.6 10c-.8 0-1.4.4-1.7 1.1l-5.8 14.4h4L47 23h5l.4 2.4H56L52.9 9.9h-3.3M50 14l1.2 5.8h-3.2l2-5.8M28 9.9l-3.2 15.5h3.9l3.2-15.5h-4m-5.6 0l-4 10.5-1.7-9c-.2-1-1-1.5-1.8-1.5H8l-.1.4c1.4.3 2.9.8 3.8 1.3.6.4.8.6 1 1.4l3 12.4H20l6.3-15.5h-4"
      />
    </svg>
  );
}

VisaIcon.propTypes = {
  className: PropTypes.string,
  monochrome: PropTypes.bool,
};

export default VisaIcon;
